import { render, staticRenderFns } from "./appcenterlist.vue?vue&type=template&id=1dcce7b2&scoped=true"
import script from "./appcenterlist.vue?vue&type=script&lang=js"
export * from "./appcenterlist.vue?vue&type=script&lang=js"
import style0 from "./appcenterlist.vue?vue&type=style&index=0&id=1dcce7b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcce7b2",
  null
  
)

export default component.exports